import React from 'react';
import { getOnlyData } from '../../utils';
import dayjs from 'dayjs';

export default function CusSiteDateTime({ date, format = 'DD.MM.YYYY HH:mm' }) {
  return date ? getOnlyData(dayjs(date), '', format) : <></>;
}
